import React from "react";
import LMSCourseCatalog from "../components/courses/CourseCatalog";

const CoursesPage: React.FC = () => {
  return <LMSCourseCatalog />;
};

export default CoursesPage;
